import { Box } from "@mui/material";
import TooltipPopover from "../../../../../components/shared/others/TooltipPopover";

const TooltipSNTaxRegime = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.3 }}>
            <TooltipPopover>
                Campo para optantes do Simples Nacional ME/EPP. Preencha como “Nenhum” caso não seja optante desse regime.
            </TooltipPopover>
        </Box>
    )
}

export default TooltipSNTaxRegime;
